import React from "react";
import { modifiedPlusImageLink } from "~/common/Constants/links";
const QuantityPlusBadge = () => {
  return <div className="flex bottom-0 left-0 absolute" data-sentry-component="QuantityPlusBadge" data-sentry-source-file="QuantityPlusBadge.tsx">
      <img src={modifiedPlusImageLink} alt="" aria-hidden="true" height={16} width={33} className="plus--logo--image h-4 w-[33.8px]" />
    </div>;
};
export default QuantityPlusBadge;